<syslink-grid
    [canView]="canView"
    [canSearch]="canSearch"
    [canRefresh]="canRefresh"
    [canAdd]="canAdd"
    [canSort]="canSort"
    [canUpdate]="canUpdate"
    [canDelete]="canDelete"
    [canFilter]="canFilter"
    [canExport]="canExport"
    [canDblClck]="canDblClck"
    [(items)]="customerCatalogs"
    [columns]="columns"
    storageKey="storageKey"
    exportFileName="Products customers catalogs"
    (onPrepareRow)="onPrepareRow.emit($event)"
    (beforeDelete)="beforeDelete.emit($event)"
    (beforeAdd)="beforeAdd.emit($event)"
    (beforeUpdate)="beforeUpdate.emit($event)"
    (afterUpdate)="afterUpdate.emit($event)"
></syslink-grid>